<template>
  <div>
    <p class="has-text-weight-bold"> {{ ligne.libelle }} </p>
    <div v-if="displayDetailLigne">
      {{ detailDate }}
      {{ detailLocation }}
      {{ detailReseauTempo }}
    </div>
    <div v-for="(ligneEnfant, index) in getLignesEnfantWithoutLocation"
         class="has-text-weight-bold mgl-20px"
         :key="index">
      {{ ligneEnfant.libelle }}
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { PERSONNALISE } from '@/configuration/devisConf';
import { CATEGORIE_DIVERS, CATEGORIE_LOCATION, CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import formatDate from '@/services/general/formatDate';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getLignesEnfantWithoutLocation() {
      return this.ligne.lignesCommande.filter((ligneEnfant) => {
        return ligneEnfant.typeProduit !== CATEGORIE_LOCATION;
      });
    },
    isReseauTempo() {
      return this.ligne.typeProduit === CATEGORIE_REGROUPEMENT;
    },
    displayDetailLigne() {
      return (this.ligne.typeProduit && this.ligne.typeProduit !== PERSONNALISE
        && this.ligne.typeProduit !== CATEGORIE_LOCATION
        && this.ligne.typeProduit !== CATEGORIE_DIVERS
      );
    },
    detailReseauTempo() {
      if (!this.isReseauTempo) return '';
      const dateDebut = this.getDateDepartReseauTempo(this.ligne).dateAnneeSemaineDebut;
      return this.$i18n.t('detailDevis.commandePartiel.tab.produitDetail.jourDepart', {
        nbFace: this.ligne.ligneReseau.qteFacesSouhaitees,
        jourDepart: moment(dateDebut).format('dddd'),
        date: formatDate(dateDebut),
      });
    },
    detailLocation() {
      const ligneLoc = this.ligne.lignesCommande.find((ligneEnfant) => {
        return ligneEnfant.typeProduit === CATEGORIE_LOCATION;
      });
      return ligneLoc ? ' - ' + ligneLoc.libelle : '';
    },
    detailDate() {
      let dateDebut = this.ligne.dateDebut;
      let dateFin = this.ligne.dateFin;
      if (this.ligne.ligneReseau && this.ligne.ligneReseau.anneeSemaine) {
        const dates = this.getDateDepartReseauTempo(this.ligne);
        dateDebut = dates.dateAnneeSemaineDebut;
        dateFin = dates.dateAnneeSemaineFin;
      }
      const nbJours = parseInt(calculDaysBetweenTwoDate(dateFin, dateDebut), 10) + 1;
      if (nbJours > 1) {
        return this.$i18n.t('detailDevis.commandePartiel.tab.produitDetail.dateMultiJour', {
          dateDebut: formatDate(dateDebut),
          dateFin: formatDate(dateFin),
          jours: nbJours,
        });
      }
      return this.$i18n.t('detailDevis.commandePartiel.tab.produitDetail.dateUnJour', {
        dateDebut: formatDate(dateDebut),
        dateFin: formatDate(dateFin),
        jours: nbJours,
      });
    },
  },
  methods: {
    getDateDepartReseauTempo(ligne) {
      const dateAnneeSemaineDebut = getDateWithAnneeSemaineAndJourDepart(
        ligne.ligneReseau.anneeSemaine,
        ligne.ligneReseau.jourDepart,
      );
      const dateAnneeSemaineFin = moment(dateAnneeSemaineDebut).add(7, 'd');
      return {
        dateAnneeSemaineDebut,
        dateAnneeSemaineFin,
      };
    },
  },
};
</script>
